<template>
<div>
  <el-table
    :data="list"
    v-loading="isSearching"
    style="width: 100%"
    row-key="taskId"
    border
    size="mini">



    <el-table-column
      width="60"
      label="采集处"
      align="center"
    >
      <template slot-scope="scope">
        <el-image class="logo" :src="logo[scope.row.collectType]"></el-image>
      </template>
    </el-table-column>

    <el-table-column
      width="86"
      prop="taskType"
      label="任务类型"
      align="center"
    >
      <template slot-scope="scope">
        <el-tag
          :type="$root.taskTypes[scope.row.taskType||''].type"
          size="mini"
          effect="dark">
          {{ $root.taskTypes[scope.row.taskType||''].text }}
        </el-tag>
      </template>
    </el-table-column>


    <el-table-column
      prop="taskName"
      label="任务名称"
    >
      <template slot-scope="scope">
        {{ scope.row.taskName }}
        <template v-if="scope.row.remark">
          <br/>
          {{ scope.row.remark }}
        </template>
      </template>
    </el-table-column>
    <el-table-column
      prop="startAt"
      label="开始时间"
      width="85"
      align="center"
    >
    </el-table-column>
    <el-table-column
      prop="endAt"
      label="结束时间"
      width="85"
      align="center"
    >
    </el-table-column>
    <el-table-column
      width="70"
      prop="taskStatus"
      label="任务状态"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.taskRate }}%
        <br/>
        <el-tag
          :type="$root.itemStatus[scope.row.taskStatus||''].type"
          size="mini"
          effect="dark">
          {{ $root.itemStatus[scope.row.taskStatus||''].text }}
        </el-tag>
      </template>
    </el-table-column>
  </el-table>

  <el-divider v-if="total>size"></el-divider>
  <div class="ta-r">
    <el-pagination
      background
      hide-on-single-page
      layout="prev, pager, next"
      @current-change="doChangePage"
      :page-size="size"
      :current-page="page"
      :total="total">
    </el-pagination>
  </div>

</div>
</template>

<script>
var timer = null, timer2 = null;
export default {
  name: 'TaskList',
  components: {
    
  },
  props: {
    statusList: {
      type: Array,
      default: ()=>{return [];},
    },
    taskTypeList: {
      type: String,
      default: "",
    },
    userId: {
      type: Number,
      default: null,
    },
    updateFlag:{
      type: Boolean,
      default: false
    },
    updateTimer:{
      type: Number,
      default: null,
    },
    auto:{
      type: Boolean,
      default: true
    },
  },
  data(){
    
    return {
      formData:{
        statusList:[],
        taskTypeList:[],
        userId:""
      },
      logo:{
        XHS:require('@/assets/common/logo_xhs.png'),
        INS:require('@/assets/common/logo_ins.png'),
      },

      total:0,
      page:1,
      size:20,
      loading:true,
      isSearching:false,
      list:[],
      
    }
  },
  mounted () {
    this.formData.userId = this.userId || "";
    this.doSearch(true);
    if(this.auto){
      timer2 = setInterval(() => {
        this.doSearch(false);
      }, 5000);
    }
  },
  destroyed () {
    if(timer2){
      clearInterval(timer2);
    }
  },
  watch: {
    statusList(newData){
      this.formData.statusList = newData || [];
      this.doSearch(true);

    },
    taskTypeList(newData){
      this.formData.taskTypeList = newData || [];
      this.doSearch(true);
    },
    
    userId(newData){
      this.formData.userId = newData;
      this.doSearch(true);
    },

    updateFlag(newData){
      if(newData){
        this.doSearch(true);
        if(this.auto){
          timer2 = setInterval(() => {
            this.doSearch(false);
          }, 5000);
        }
        
      } else if(timer2){
        clearInterval(timer2);
      }
    },
    
    updateTimer(newData){
      if(newData){
        this.doSearch(true);
      }
    }
    
  },
  methods:{
    getList(url){
      this.isSearching = true;
      this.request.get(url).then(res=>{
        this.isSearching = false;
        this.list = [];
        this.total = 0;
        this.page = 1;
        if(!res){return ;}
        this.list = res.results || [];
        // this.list.map(d=>{
        //   d.resources.unshift({type:"IMAGE",url:d.thumbnailUrl});
        // })
        this.list.forEach(d=>{
          d.taskRate = (d.taskRate*100).toFixed(2);
        })
        this.total = res.total;
        // this.total = 646;
        this.page = res.page;

      });
    },
    doSearch(resetPage = true){
      if(timer){
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        var formData = {page:this.page,size:this.size,...this.formData};
        if(resetPage){formData.page = 1;}
        var params = this.$root.object2urlparams(formData);
        this.getList(`/api/v1/collectsTask/paging?${params}`);
      }, 200);
      
      
    },
    doChangePage(currentPage){
      var formData = {page:this.page,size:this.size,...this.formData};
      formData.page = currentPage;
      var params = this.$root.object2urlparams(formData);
      this.getList(`/api/v1/collectsTask/paging?${params}`);
    },
  } 
}
</script>

<style lang="less" scoped>

</style>
